export default "__VITE_ASSET__vLCZHkVS__"